import React, { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined); // undefined = loading, null = guest

  useEffect(() => {
    (async () => {
      const token = localStorage.getItem("m16_token");
      if (!token) { setUser(null); return; }
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        localStorage.removeItem("m16_token");
        setUser(null);
      }
    })();
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("m16_token", data.token);
      localStorage.setItem("m16_returning_user", "1");
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e) };
    }
  };

  const register = async (email, password, name, home_location = null) => {
    try {
      const { data } = await api.post("/auth/register", { email, password, name, home_location });
      localStorage.setItem("m16_token", data.token);
      localStorage.setItem("m16_returning_user", "1");
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e) };
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) { /* ignore */ }
    localStorage.removeItem("m16_token");
    localStorage.removeItem("m16_guest");
    sessionStorage.setItem("m16_discount_banner_dismissed", "1");
    setUser(null);
  };

  const refreshUser = async () => {
    const token = localStorage.getItem("m16_token");
    if (!token) return;
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch { /* ignore */ }
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, refreshUser, isAdmin: user?.role === "admin" }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
};
